<div id="contact-popup-container">
  <app-contact-us-form (completed)="close()"> </app-contact-us-form>
</div>
